import z from "zod";
import { looseUuid } from "@thalamos/common";
export const MentalHealthCareProviderIdSchema = looseUuid().brand();
export const MentalHealthCareProviderSchema = z
    .object({
    id: MentalHealthCareProviderIdSchema,
    name: z.string().min(1).max(255),
    email: z.email(),
    trustId: looseUuid().nullish(),
})
    .brand();
//# sourceMappingURL=mentalHealthCareProvider.js.map